import styled, { keyframes } from "styled-components";
import { layout, LayoutProps, space, SpaceProps } from "styled-system";

const shimmer = keyframes`
  from { background-position: -200px 0; }
  to { background-position: calc(200px + 100%) 0; }
`;

export type SkeletonProps = LayoutProps & SpaceProps;

/**
 * A grey placeholder bar shown while content loads. Set the size with the
 * styled-system width/height props, e.g. <Skeleton width="60%" height={14} />.
 */
export const Skeleton = styled.div.attrs({
  "aria-hidden": true,
})<SkeletonProps>`
  width: 100%;
  height: 14px;
  border-radius: 6px;
  background: ${(props) => props.theme.colors.grey4}
    linear-gradient(
      90deg,
      ${(props) => props.theme.colors.grey4} 0,
      ${(props) => props.theme.colors.grey6} 50%,
      ${(props) => props.theme.colors.grey4} 100%
    )
    no-repeat;
  background-size: 200px 100%;
  animation: ${shimmer} 1.3s ease-in-out infinite;
  ${layout};
  ${space};

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
